import { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

export default function StatusAndSourceCharts() {
    const { t } = useTranslation();

    const funnelData = [
        { name: t('overview_report.care_1'), value: 2, color: "#ef6b5a" },
        { name: t('overview_report.purchased'), value: 3, color: "#3b82f6" },
        { name: t('overview_report.new_customer'), value: 1, color: "#22a6d5" },
        { name: t('overview_report.canceled'), value: 1, color: "#ff2d0a" }
    ];

    const [isDark, setIsDark] = useState(
        document.body.classList.contains("dark")
    );

    const [active, setActive] = useState(
        funnelData.reduce((acc: any, cur) => {
            acc[cur.name] = true;
            return acc;
        }, {})
    );

    useEffect(() => {

        const observer = new MutationObserver(() => {
            setIsDark(document.body.classList.contains("dark"));
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"]
        });

        return () => observer.disconnect();

    }, []);

    const toggle = (name: string) => {

        setActive((prev: any) => ({
            ...prev,
            [name]: !prev[name]
        }));

    };

    const funnelSeries = funnelData
        .filter((item) => active[item.name])
        .map((item) => ({
            name: item.name,
            value: item.value,
            itemStyle: { color: item.color }
        }));

    const funnelOption = {
        backgroundColor: "transparent",

        tooltip: {
            trigger: "item",
            textStyle: {
                color: isDark ? "#fff" : "#000"
            }
        },

        textStyle: {
            color: isDark ? "#e5e7eb" : "#374151"
        },

        series: [
            {
                type: "funnel",
                sort: "none",
                left: "15%",
                width: "70%",
                top: 20,
                bottom: 20,
                label: { show: false },
                data: funnelSeries
            }
        ]
    };

    const sourceOption = {
        backgroundColor: "transparent",

        tooltip: {
            trigger: "item",
            textStyle: {
                color: isDark ? "#fff" : "#000"
            }
        },

        legend: {
            show: false
        },

        textStyle: {
            color: isDark ? "#e5e7eb" : "#374151"
        },

        series: [
            {
                type: "pie",
                radius: ["50%", "70%"],
                center: ["40%", "50%"],

                data: [
                    {
                        value: 4000,
                        name: "Whatsapp",
                        itemStyle: { color: "#5b5bd6" }
                    },
                    {
                        value: 3000,
                        name: t('overview_report.other'),
                        itemStyle: { color: "#18a874" }
                    }
                ],

                label: { show: false }
            }
        ]
    };

    return (
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">

            {/* Funnel */}

            <div className="lg:col-span-2 bg-white dark:bg-[#1f1f1f] rounded-xl p-5">

                <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                    {t('overview_report.status_funnel')}
                </h3>

                <div className="grid grid-cols-[240px_1fr] gap-6">

                    {/* Status list */}

                    <div>

                        <p className="text-sm text-gray-500 mb-3">
                            {t('overview_report.status_list')}
                        </p>

                        <div className="space-y-2">

                            {funnelData.map((item) => {

                                const isActive = active[item.name];

                                return (
                                    <div
                                        key={item.name}
                                        onClick={() => toggle(item.name)}
                                        className={`flex items-center justify-between p-3 rounded-lg border cursor-pointer

                    ${isActive
                                                ? "bg-gray-50 dark:bg-[#2a2a2a]"
                                                : "opacity-40"}
                    `}
                                    >

                                        <div className="flex items-center gap-3">

                                            <div
                                                className="w-3 h-3 rounded"
                                                style={{ background: item.color }}
                                            />

                                            <span className="text-sm text-gray-800 dark:text-gray-200">
                                                {item.name}
                                            </span>

                                        </div>

                                        <span className="text-sm text-gray-500">
                                            {item.value}
                                        </span>

                                    </div>
                                );
                            })}

                        </div>

                    </div>

                    {/* Funnel chart */}

                    <ReactECharts
                        option={funnelOption}
                        style={{ height: 350 }}
                    />

                </div>

            </div>

            {/* Donut chart */}

            <div className="bg-white dark:bg-[#1f1f1f] rounded-xl p-5">

                <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-4">
                    {t('overview_report.customer_by_source')}
                </h3>

                <div className="flex items-center gap-6">

                    <ReactECharts
                        option={sourceOption}
                        style={{ height: 220, width: 220 }}
                    />

                    <div className="space-y-3">

                        <div className="flex items-center gap-3">
                            <div className="w-3 h-3 rounded bg-[#5b5bd6]" />
                            <div>
                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                    Whatsapp
                                </p>
                                <p className="text-xs text-gray-500">
                                    4 KH · 57.14%
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <div className="w-3 h-3 rounded bg-[#18a874]" />
                            <div>
                                <p className="text-sm text-gray-800 dark:text-gray-200">
                                    {t('overview_report.other')}
                                </p>
                                <p className="text-xs text-gray-500">
                                    3 KH · 42.86%
                                </p>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}